<!--
 * @Author: weixiuting weixiuting@qq.com
 * @Date: 2022-11-22 16:29:44
 * @LastEditors: weixiuting weixiuting@qq.com
 * @LastEditTime: 2023-09-27 11:37:03
 * @FilePath: \plantingSubsidy_web\src\views\statistics-charts\insurance-statistics\components\RegionalRankings\index.vue
 * @Description: 承保理赔一张图-统计承保统计图- 最新  各地区承保情况、各保险公司承保情况-->
 <template>
  <div class="chart_box"
       ref="regionalRankingsChart">
    <!--    id="regionalRankingsChart" -->

  </div>

</template>
<script>
import moment from 'moment'
const labelOption = {
  // show: true,
  position: 'insideBottom',
  distance: 20,
  align: 'left',
  verticalAlign: 'middle',
  // rotate: 90,
  // formatter: '{b}  {name|{a}}',
  fontSize: 16,
  rich: {
    name: {}
  }
}
let dataSetDefault1 = {

  dimensions: ['cityName', '', '承保面积'],
  source: [
    //   { cityName: '哈尔滨', '': 1000, '承保面积': 1000 },
    //   { cityName: '齐齐哈尔', '': 1000, '承保面积': 800 },
    //   { cityName: '牡丹江', '': 1000, '承保面积': 500 },
    //   { cityName: '绥化', '': 1000, '承保面积': 100 }
  ]

}
let dataSetDefault2 = {

  dimensions: ['companyName', '', '承保面积'],
  source: [
    // { companyName: '保险公司1', '': 1000, '承保面积': 1000 },
    // { companyName: '保险公司2', '': 1000, '承保面积': 800 },
    // { companyName: '保险公司3', '': 1000, '承保面积': 500 },
    // { companyName: '保险公司4', '': 1000, '承保面积': 100 }
  ]
}
export default {
  props: {
    year: {
      type: String,
      default: ''

    },
    barType: {
      type: String,
      default: '1'

    }
  },
  data () {
    return {
      level: this.$store.state.account.user.level,
      account: this.$store.state.account,
      cityCode: '',
      chart: null,
      dataset: (this.barType === '1' ? dataSetDefault1 : dataSetDefault2)
    }
  },

  created () {
    this.cityCode = this.account.userArea.city
    // if (this.level <= 3) {
    //   // 全省历年投保情况分析
    //   // this.getMapByCity()
    // }
    this.getData()
  },
  mounted () {
    this.chart = this.$echarts.init(this.$refs.regionalRankingsChart)
    window.addEventListener('resize', () => {
      this.chart.resize()
    })
    this.initData()
  },

  methods: {
    getData () {
      let url = ''
      if (this.barType === '1') {
        // 各地区承保情况
        url = '/statistics/statisticsBase/getMapByArea'
      } else if (this.barType === '2') {
        // 各保险公司承保情况
        url = '/statistics/statisticsBase/getCbAcreage'
      }
      this.$get(url, {
        // year: moment().format('YYYY'),
        year: this.year,
        province: this.$store.state.account.user.province || '230000000000',
        city: this.cityCode || '',
        county: this.$store.state.account.userArea.county || ''
      })
        .then(r => {
          let data = r.data.data
          if (this.barType === '1' && data && data.dataList.length > 0) {
            // 设置最大值（背景柱）
            let max = data.dataList.map(i => i['承保总面积'])
            max = Number((max.sort((a, b) => (b - a))[0] / 10000).toFixed(2))
            dataSetDefault1.source = data.dataList.map(i => ({
              cityName: i.areaName,
              '': max,
              '承保面积': Number((i['承保总面积'] / 10000).toFixed(2))
            }))
          }

          if (this.barType === '2' && data && data.companyCbAcreage && data.companyCbAcreage.source && data.companyCbAcreage.source.length > 0) {
            // 设置最大值（背景柱）
            let max = data.companyCbAcreage.source.map(i => i['companyCbAcreage'])
            max = Number((max.sort((a, b) => (b - a))[0] / 10000).toFixed(2))
            dataSetDefault2.source = data.companyCbAcreage.source.map(i => ({
              companyName: i.headCompanyName,
              '': max,
              '承保面积': Number((i['companyCbAcreage'] / 10000).toFixed(2))
            }))
          }

          this.dataset = (this.barType === '1' ? dataSetDefault1 : dataSetDefault2)

          this.initData()
        })
        .catch(() => { })
    },

    initData () {
      this.initChart()
    },
    initChart () {
      let option = {
        title: {
          text: '',
          // subtext: '(2020年5月6日)',
          left: 'right'
        },
        grid: {
          show: false,
          top: '20%', // 一下数值可为百分比也可为具体像素值
          right: '0%',
          bottom: '20%',
          left: '6%'

        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#103164',
          borderColor: '#2a69c6',
          textStyle: {
            color: '#c6e1fc'
            // fontSize: 14,
            // fontWeight: 'bold',
            // padding: 4
          },
          className: 'custom_tooltip_box',
          formatter: (params, a, b) => {
            let param = params

            let itemHtml = ''
            let i = 0
            let color = ['rgba(68, 147, 255, 1)']
            for (let key in param[0].data) {
              if (key.length >= 2 && key.length <= 7) {
                itemHtml += ` <div class="custom_tooltip_item" ><span style='display:inline-block;width:10px;height:10px;border-radius:50%;background:${color[i++]}'></span>
          <span style='display:inline-block;width:80px;'>${key}</span> <span>${param[0].data[key]}万亩</span>

           </div>`
              }
            }

            return `<div class='custom_tooltip_style'>
            <div class='custom_tooltip_title'>

            ${(this.barType === '1') ? param[0].data.cityName : param[0].data.companyName}

            </div>
            <div class="custom_tooltip_inner">


           ${itemHtml}
            </div>

            </div>`
          }
        },
        dataset: this.dataset,

        dataZoom: [{
          // type: 'slider',
          type: 'inside',
          backgroundColor: 'rgba(47,69,84,0.4)',
          borderColor: 'rgaba(255,255,255,0.01)',
          fillerColor: 'rgba(167,183,204,0.1)',
          // show: true, // flase直接隐藏图形
          show: this.dataset.source.length > 10, // flase直接隐藏图形
          height: 3,
          xAxisIndex: [0],
          left: '6%', // 滚动条靠左侧的百分比
          bottom: '5%',
          start: 0, // 滚动条的起始位置
          end: Number((100 / (this.dataset.source.length / 10)).toFixed(0))// 滚动条的截止位置（按比例分割你的柱状图x轴长度）
        }],
        legend: {
          show: false

        },
        toolbox: {
          show: true,
          orient: 'vertical',
          left: 'right',
          top: 'center'
          // feature: {
          //   mark: { show: true },
          //   dataView: { show: true, readOnly: false },
          //   magicType: { show: true, type: ['line', 'bar', 'stack'] },
          //   restore: { show: true },
          //   saveAsImage: { show: true }
          // }
        },
        xAxis: [
          {
            type: 'category',
            axisTick: { show: false },
            position: {
              top: '10%'
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(255,255,255,0.3)'
              }
            },
            /* x轴标签 */
            axisLabel: {
              rotate: (this.dataset.source.length > 8 ? 20 : 0),
              color: '#ADADAD',
              fontSize: 12,
              margin: 16

            }

          }
        ],
        yAxis: [
          {
            name: '万亩',
            nameTextStyle: {
              color: '#b0aeaf',
              fontSize: 14,
              margin: 10
            },
            fontSize: 14,
            type: 'value',

            axisLabel: {
              color: '#b0aeaf',
              fontSize: 14
              // formatter: function (value, index) {
              //   if (value > 1) { return (value / 10000).toFixed(0) } else return value
              // }
              // formatter: function (value, index) {
              //   if (value === 0) {
              //     return value
              //   } else if (value >= 10000) {
              //     return value / 10000 + '万亩'
              //   } else {
              //     return value + '亩'
              //   }
              // }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: 'rgba(255, 255, 255, 0.3)'
              }
            }
          }
        ],
        // color: ['#3e66e2', '#4ab2e9', '#12d5d3', '#ff9023'],
        // color: ['#fa9d36', 'rgba(47,107,242,0.8)', 'rgba(77,152,254,0.8)', 'rgba(5,201,208,0.8)', 'rgba(66,47,242,0.8)'],
        series: [
          // 背景柱图
          {
            name: '',
            type: 'bar',
            barMinWidth: 14,
            barWidth: 26,
            barGap: 0.2,
            color: 'rgba(255,255,255,0.05)'

          },

          {
            // name: '大豆',
            type: 'pictorialBar',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(255, 255, 255, 0.05)'
            },

            symbol: 'rect',
            barMaxWidth: 20,
            barMinWidth: 14,
            barWidth: 18,
            barGap: 0.2,
            symbolOffset: [0, 1],
            label: labelOption,
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              color: (this.barType === '1' ? new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(68, 209, 255, 1)' },
                { offset: 1, color: 'rgba(156, 233, 255, 0.35)' }
              ]) : new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(68, 147, 255, 1)' },
                { offset: 1, color: 'rgba(65, 144, 250, 0.35)' }
              ]))
            }

            // data: [220, 182, 191, 234, 290, 330, 310, 182, 191, 234]
          }
        ]
      }
      this.chart.setOption(option, true)
    }
  },
  watch: {
    year: {

      handler (newVal) {
        if (this.level <= 3) {
          // 全省历年投保情况分析
          this.getData()
        }
      }
    }

  }
}
</script>
<style lang="less" scoped>
/deep/.custom_tooltip_box {
  padding: 0 !important;
  border: none !important;
  background-color: transparent !important;
  height: auto !important;
  box-shadow: none !important;
  .custom_tooltip_style {
    line-height: 24px;
    padding: 4px 10px 5px;
    border: 1px solid #2a69c6;
    border-radius: 4px;
    background: #103164;
    color: #c6e1fc;
  }
  .custom_tooltip_item {
    padding-right: 10px;
  }
  .chart_box {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/statistics-charts/insurance-statistics/components/v1/RegionalRankings/index.vue